export const TOUR_GUIDE_RUN = 'TOUR_GUIDE_RUN';
export const TOUR_GUIDE_STEPS = 'TOUR_GUIDE_STEPS';
export const TOUR_GUIDE_STEP_INDEX = 'TOUR_GUIDE_STEP_INDEX';
export const TOUR_GUIDE = 'TOUR_GUIDE';